import revive_payload_client_4sVQNw7RlN from "/home/runner/work/srov-investor-app/srov-investor-app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/runner/work/srov-investor-app/srov-investor-app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/runner/work/srov-investor-app/srov-investor-app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/runner/work/srov-investor-app/srov-investor-app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/home/runner/work/srov-investor-app/srov-investor-app/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/runner/work/srov-investor-app/srov-investor-app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/home/runner/work/srov-investor-app/srov-investor-app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/home/runner/work/srov-investor-app/srov-investor-app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/runner/work/srov-investor-app/srov-investor-app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_tLmAP220nC from "/home/runner/work/srov-investor-app/srov-investor-app/node_modules/@nuxt/image/dist/runtime/plugin.mjs";
import plugin_tbFNToZNim from "/home/runner/work/srov-investor-app/srov-investor-app/node_modules/@zadigetvoltaire/nuxt-gtm/dist/runtime/plugin.mjs";
import plugin_8SbxDRbG6Y from "/home/runner/work/srov-investor-app/srov-investor-app/node_modules/dayjs-nuxt/dist/runtime/plugin.mjs";
import i18n_yfWm7jX06p from "/home/runner/work/srov-investor-app/srov-investor-app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import amplify_k7zpSlaowH from "/home/runner/work/srov-investor-app/srov-investor-app/node_modules/@cfgtech/srov-shared/plugins/amplify.ts";
import current_version_client_xdxKKs8d8Y from "/home/runner/work/srov-investor-app/srov-investor-app/node_modules/@cfgtech/srov-shared/plugins/current-version.client.ts";
import amplify_cCHdTinyKG from "/home/runner/work/srov-investor-app/srov-investor-app/plugins/amplify.ts";
import chart_client_qQ92gke75l from "/home/runner/work/srov-investor-app/srov-investor-app/plugins/chart.client.ts";
import gtmUserData_client_n7tOLzgZvF from "/home/runner/work/srov-investor-app/srov-investor-app/plugins/gtmUserData.client.ts";
import gtmUsernameVariable_client_vqu5pZGEVh from "/home/runner/work/srov-investor-app/srov-investor-app/plugins/gtmUsernameVariable.client.ts";
import notiwind_qYGIDwLcpw from "/home/runner/work/srov-investor-app/srov-investor-app/plugins/notiwind.ts";
import scroll_to_hash_CTCniV1Z3w from "/home/runner/work/srov-investor-app/srov-investor-app/plugins/scroll-to-hash.ts";
import sentry_client_shVUlIjFLk from "/home/runner/work/srov-investor-app/srov-investor-app/plugins/sentry.client.ts";
import sentryUser_client_3Dh32JAKWP from "/home/runner/work/srov-investor-app/srov-investor-app/plugins/sentryUser.client.ts";
import smartlook_client_sDRAy1PyJv from "/home/runner/work/srov-investor-app/srov-investor-app/plugins/smartlook.client.ts";
import svgSprite_client_NXGsy3rR9P from "/home/runner/work/srov-investor-app/srov-investor-app/plugins/svgSprite.client.ts";
import typeform_client_WVOoYpVmSA from "/home/runner/work/srov-investor-app/srov-investor-app/plugins/typeform.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_tLmAP220nC,
  plugin_tbFNToZNim,
  plugin_8SbxDRbG6Y,
  i18n_yfWm7jX06p,
  amplify_k7zpSlaowH,
  current_version_client_xdxKKs8d8Y,
  amplify_cCHdTinyKG,
  chart_client_qQ92gke75l,
  gtmUserData_client_n7tOLzgZvF,
  gtmUsernameVariable_client_vqu5pZGEVh,
  notiwind_qYGIDwLcpw,
  scroll_to_hash_CTCniV1Z3w,
  sentry_client_shVUlIjFLk,
  sentryUser_client_3Dh32JAKWP,
  smartlook_client_sDRAy1PyJv,
  svgSprite_client_NXGsy3rR9P,
  typeform_client_WVOoYpVmSA
]